<template>
  <main
    class="main-content flex-grow-1 p-4 overflow-auto mt-6 d-flex flex-column gap-3"
    style="background-color: #f8f9fa"
  >
    <div class="d-flex justify-content-between align-items-center mt-4">
      <div class="d-flex align-items-center gap-2">
        <img
          src="../../../public/assets/icons/ic_chevron_left.svg"
          alt="back-icon"
          class="cursor-pointer"
          @click="this.$router.push(`/user-management`)"
        />
        <div
          class="text-header-page"
          style="
            color: var(--Dark-100, #022326);
            font-size: 24px;
            font-style: normal;
            font-weight: 600;
            line-height: 32px;
          "
        >
          User Details
        </div>
      </div>
      <div class="d-flex gap-2">
        <button
          class="custom-button"
          style="
            color: var(--Dark-Green, #022326);
            font-family: Inter;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          "
          @click="onEditRole(user)"
        >
          Edit Role
        </button>
        <button 
          v-if="user?.status === 'pending'"
          class="custom-button resend-email-button" 
          @click="onResendEmail(user)"
          :disabled="isResendingEmail"
        >
          <span class="resend-text">
            {{ isResendingEmail ? 'Sending...' : 'Resend Email' }}
          </span>
        </button>
        <button class="custom-button" @click="onSuspendUser(user)">
          <img
            src="../../../public/assets/icons/ic_forbidden.svg"
            alt="icon"
            class="forbidden-icon"
          />
          <div
            style="
              color: var(--System-Red, #ff3b30);
              font-family: Inter;
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
            "
          >
            Suspend
          </div>
        </button>
      </div>
    </div>

    <div
      v-if="isLoading"
      class="row g-2 align-items-start p-4 flex-fill align-self-stretch border bg-white"
      style="border-radius: 16px; border-color: #dae0e2; background: #fff"
    >
      <div v-for="n in 6" :key="n" class="col-2 d-flex flex-column gap-2">
        <div class="skeleton skeleton-text w-50"></div>
        <div class="skeleton skeleton-text w-75"></div>
      </div>
    </div>

    <div
      v-else-if="user"
      class="row g-2 align-items-start p-4 flex-fill align-self-stretch border bg-white"
      style="
        border-radius: 16px;
        border-color: var(--Background-Grey, #dae0e2);
        background: var(--Dark-White, #fff);
        word-break: break-all;
      "
    >
      <div class="col-2 d-flex flex-column">
        <div
          style="
            color: var(--Dark-50, #7c8c8d);

            /* Body / Reg / Small */
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 18px; /* 128.571% */
            letter-spacing: 0.105px;
          "
        >
          Fullname
        </div>
        <div
          style="
            color: var(--Dark-100, #022326);
            /* Body / Bold / Medium */
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: 24px; /* 150% */
            letter-spacing: 0.12px;
          "
        >
          {{ user?.fullname }}
        </div>
      </div>
      <div class="col-2 d-flex flex-column">
        <div
          style="
            color: var(--Dark-50, #7c8c8d);

            /* Body / Reg / Small */
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 18px; /* 128.571% */
            letter-spacing: 0.105px;
          "
        >
          Email
        </div>
        <div
          style="
            color: var(--Dark-100, #022326);
            /* Body / Bold / Medium */
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: 24px; /* 150% */
            letter-spacing: 0.12px;
          "
        >
          {{ user?.email }}
        </div>
      </div>
      <div class="col-2 d-flex flex-column">
        <div
          style="
            color: var(--Dark-50, #7c8c8d);

            /* Body / Reg / Small */
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 18px; /* 128.571% */
            letter-spacing: 0.105px;
          "
        >
          Phone Number
        </div>
        <div
          style="
            color: var(--Dark-100, #022326);
            /* Body / Bold / Medium */
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: 24px; /* 150% */
            letter-spacing: 0.12px;
          "
        >
          {{ user?.phone_number }}
        </div>
      </div>
      <div class="col-2 d-flex flex-column">
        <div
          style="
            color: var(--Dark-50, #7c8c8d);

            /* Body / Reg / Small */
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 18px; /* 128.571% */
            letter-spacing: 0.105px;
          "
        >
          Role
        </div>
        <div
          style="
            color: var(--Dark-100, #022326);
            /* Body / Bold / Medium */
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: 24px; /* 150% */
            letter-spacing: 0.12px;
          "
        >
          {{ user?.role?.roles_name }}
        </div>
      </div>
      <div class="col-2 d-flex flex-column">
        <div
          style="
            color: var(--Dark-50, #7c8c8d);

            /* Body / Reg / Small */
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 18px; /* 128.571% */
            letter-spacing: 0.105px;
          "
        >
          Join Date
        </div>
        <div
          style="
            color: var(--Dark-100, #022326);
            /* Body / Bold / Medium */
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: 24px; /* 150% */
            letter-spacing: 0.12px;
          "
        >
          {{ user?.join_date }}
        </div>
      </div>
      <div class="col-2 d-flex flex-column">
        <div
          style="
            color: var(--Dark-50, #7c8c8d);

            /* Body / Reg / Small */
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 18px; /* 128.571% */
            letter-spacing: 0.105px;
          "
        >
          Status
        </div>
        <span
          :class="{
            'active-badge': user.status === 'active',
            'pending-badge': user.status === 'pending',
            'suspended-badge': user.status === 'suspended',
          }"
        >
          <div
            :class="{
              'text-active-badge': user.status === 'active',
              'text-pending-badge': user.status === 'pending',
              'text-suspended-badge': user.status === 'suspended',
            }"
          >
            {{ capitalizeWords(user.status) }}
          </div>
        </span>
      </div>
    </div>

    <div
      class="d-flex flex-column align-items-start flex-fill align-self-stretch border bg-white"
      style="
        border-radius: 16px;
        border-color: var(--Background-Grey, #dae0e2);
        background: var(--Dark-White, #fff);
      "
    >
      <!-- Tabs -->
      <div class="px-4 py-3 border-bottom w-100" style="border-color: #dae0e2">
        <ul
          class="nav nav-tabs d-inline-flex w-auto"
          style="
            display: flex;
            gap: 4px;
            padding: 4px;
            align-items: flex-start;
            border-radius: 8px;
            background: var(--Background-Light-Grey, #f4f6f6);
          "
        >
          <li class="nav-item">
            <button
              class="nav-link"
              :class="{ active: activeTab === 'log' }"
              @click="activeTab = 'log'"
            >
              Log Activity
            </button>
          </li>
          <li class="nav-item">
            <button
              class="nav-link"
              :class="{ active: activeTab === 'account' }"
              @click="activeTab = 'account'"
            >
              Account History
            </button>
          </li>
        </ul>
      </div>

      <!-- Tab Content -->
      <div class="w-100">
        <div v-if="activeTab === 'log'">
          <LogActivityComponent />
        </div>
        <div v-if="activeTab === 'account'">
          <AccountHistoryComponent
            :history="user?.histories || []"
            :isLoading="isLoading"
          />
        </div>
      </div>

      <SuspendUserModalComponent
        :show="showSuspendModal"
        :user="selectedUser"
        @close="showSuspendModal = false"
        @suspended="onUserSuspended"
      />

      <EditUserModalComponent
        :show="showEditModal"
        :user="selectedUser"
        :roleList="roleList"
        @close="showEditModal = false"
        @updated="onUserUpdated"
      />
    </div>
  </main>
</template>

<script>
import LogActivityComponent from "./LogActivityComponent.vue";
import AccountHistoryComponent from "./AccountHistoryComponent.vue";
import SuspendUserModalComponent from "./SuspendUserModalComponent.vue";
import EditUserModalComponent from "./EditUserModalComponent.vue";
import {
  getUserManagementDetail,
  getUserManagementRoles,
  resendEmail,
} from "@/api/user-management";

export default {
  name: "UserActivityTabs",
  components: {
    LogActivityComponent,
    AccountHistoryComponent,
    SuspendUserModalComponent,
    EditUserModalComponent,
  },
  data() {
    return {
      activeTab: "log", // default tab
      merchantUser: null,
      isLoading: false,
      showEditModal: false,
      showSuspendModal: false,
      selectedUser: null,
      roleList: [],
      rolesIsLoading: false,
      isResendingEmail: false,
    };
  },
  computed: {
    user() {
      return this.merchantUser;
    },
  },
  methods: {
    async getRoles() {
      this.rolesIsLoading = true;

      try {
        const response = await getUserManagementRoles();

        if (response && response.status === "success" && response.data) {
          this.roleList = response.data.data || response.data || [];
        } else {
          this.roleList = [];
        }
      } catch (error) {
        this.roleList = [];
        this.$swal("Failed to fetch roles data");
      } finally {
        this.rolesIsLoading = false;
      }
    },
    async fetchUserManagementDetail() {
      try {
        this.isLoading = true; // start loading
        const route = this.$route; // use this.$route instead of useRoute()
        const merchantUserId = route.params.id;

        const response = await getUserManagementDetail(merchantUserId);

        if (response && response.status === "success" && response.data) {
          this.merchantUser = response.data.data || response.data || null;
        } else {
          this.merchantUser = null;
        }
      } catch (error) {
        this.merchantUser = null;
        this.$swal("Failed to fetch user detail");
      } finally {
        this.isLoading = false; // stop loading
      }
    },
    capitalizeWords(str) {
      if (!str) return "";
      return str
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },
    onSuspendUser(user) {
      this.selectedUser = user;
      this.showSuspendModal = true;
    },
    async onUserSuspended() {
      this.showSuspendModal = false;
      this.selectedUser = null;
      this.fetchUserManagementDetail();
      this.$swal("Success!", "User has been suspended!", "success");
    },
    onEditRole(user) {
      this.selectedUser = user;
      this.showEditModal = true;
    },
    async onUserUpdated() {
      this.showEditModal = false;
      this.selectedUser = null;
      this.fetchUserManagementDetail();
      this.$swal("Success!", "User has been updated!", "success");
    },
    async onResendEmail(user) {
      if (!user?.id) {
        this.$swal("Error", "User ID is missing", "error");
        return;
      }

      try {
        this.isResendingEmail = true;
        const response = await resendEmail(user.id);

        if (response && response.status === "success") {
          this.$swal("Success!", "Email has been resent successfully!", "success");
        } else {
          this.$swal("Error", "Failed to resend email. Please try again.", "error");
        }
      } catch (error) {
        console.error("Error resending email:", error);
        this.$swal("Error", "Failed to resend email. Please try again.", "error");
      } finally {
        this.isResendingEmail = false;
      }
    },
  },
  mounted() {
    this.getRoles();
    this.fetchUserManagementDetail();
  },
};
</script>

<style scoped>
.pending-badge {
  display: flex;
  padding: 2px 4px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: var(--Orange-10, #fff8e5);
}

.text-pending-badge {
  color: var(--Orange-100, #f80);
  text-align: center;

  /* Body / Bold / Xsmall */
  font-family: "IBM Plex Sans Devanagari";
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 14px; /* 116.667% */
  letter-spacing: 0.09px;
}

.active-badge {
  display: flex;
  padding: 2px 4px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: var(--Green-10, #e3fff1);
}

.text-active-badge {
  color: var(--Green-100, #06c270);
  text-align: center;

  /* Body / Bold / Xsmall */
  font-family: "IBM Plex Sans Devanagari";
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 14px; /* 116.667% */
  letter-spacing: 0.09px;
}

.suspended-badge {
  display: flex;
  padding: 2px 4px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: var(--Red-10, #ffe5e5);
}

.text-suspended-badge {
  color: var(--Red-100, #ff3b3b);
  text-align: center;

  /* Body / Bold / Xsmall */
  font-family: "IBM Plex Sans Devanagari";
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 14px; /* 116.667% */
  letter-spacing: 0.09px;
}

.custom-button {
  display: flex;
  height: 32px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;

  border-radius: 4px;
  border: 1px solid var(--Background-Grey, #dae0e2);
  background: #fff;
}

.resend-email-button {
  display: flex;
  height: 32px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  /* border-radius: 4px; */
  /* border: 1px solid var(--Green-100, #128050); */
  background: #fff;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
}

.resend-email-button:hover:not(:disabled) {
  background: linear-gradient(180deg, #43bb75 0%, #1c9762 100%);
  border: 1px solid var(--Green-100, #128050);
  box-shadow: inset 0px 2px 1px 0px #ffffff40;
}

.resend-email-button:hover:not(:disabled) .resend-text {
  color: white;
}

.resend-email-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.resend-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.resend-text {
  color: var(--Dark-Green, #022326);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  white-space: nowrap;
}

.nav-tabs .nav-link.active {
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: var(--Dark-White, #fff);

  /* Button Shadow */
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.nav-tabs .nav-link {
  border-radius: 8px;
  color: #6c757d;
  transition: all 0.2s ease-in-out;
}

.nav-tabs .nav-link:hover {
  background: var(--Dark-White, #fff);
  color: var(--Dark-100, #022326);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

@keyframes pulse {
  0% {
    background-color: #e0e0e0;
  }
  50% {
    background-color: #f0f0f0;
  }
  100% {
    background-color: #e0e0e0;
  }
}
</style>
